import { useRef, useEffect } from 'react'

/**
 * Returns true if it's the first render of a component
 */
export function useIsFirstRender() {
  const IsFirstRenderRef = useRef(true)
  useEffect(() => {
    IsFirstRenderRef.current = false
  }, [])
  return IsFirstRenderRef.current
}
